import { TAppDetails, TRESPONSE_LotListing, TStockType } from '@monorepo/types';
import { UiFilterModifiers } from '../ui-filter.modifier';
import { TDateGroupInfo, TFilterGroupModel } from '../ui-filter.types';

const fabricFilterToDisplayNameMap: Record<TRESPONSE_LotListing['selectedFilters'][number]['filterType'], string> = {
  DATE: 'date',
  LOT_STATUS: 'Status',
  BUYER: 'All Buyers',
  PLM: 'All PLM No',
  PO: 'All POs',
  STYLE: 'All Styles',
  COLOR: 'All Colors',
  SUPPLIER_NAME: 'All Suppliers',
  LOT_NO: 'All Lot no',
  FABRIC_VARIANT: 'All Variant',
  FABRIC_TYPE: 'All Types',
  MATERIAL_CODE: 'All Material Code/PDM',
  ITEM_NAMES: 'All Item Names',
  GRN_STATUS: 'All GRN Status',
  PACKED: 'Packed',
};

const DATE_FILTER: TDateGroupInfo = {
  type: 'DATE_FILTER',
  key: 'DATE',
  selectedValues: [],
  items: [
    {
      isSelected: false,
      value: 'PAST_ONE_DAY',
      displayText: 'YESTERDAY',
    },
    {
      isSelected: false,
      value: 'PAST_ONE_MONTH',
      displayText: 'PAST MONTH',
    },
    {
      isSelected: false,
      value: 'PAST_ONE_WEEK',
      displayText: 'PAST WEEK',
    },
  ],
  text: 'DATE',
};

const filterTypeToHeaderKeyMap: Record<TRESPONSE_LotListing['selectedFilters'][number]['filterType'], string> = {
  SUPPLIER_NAME: 'supplierName',
  BUYER: 'buyer',
  PLM: 'plm',
  DATE: 'date',
  LOT_STATUS: 'lotStatus',
  PO: 'po',
  STYLE: 'style',
  COLOR: 'color',
  LOT_NO: 'lotNo',
  FABRIC_VARIANT: 'fabricVariant',
  FABRIC_TYPE: 'fabricType',
  MATERIAL_CODE: 'materialCode',
  ITEM_NAMES: 'itemName',
  GRN_STATUS: 'lotGRNStatus',
  PACKED: 'packed',
};

export const FABRIC_FILTER_LOT_LISTING_MODEL = {
  getFiltersDisplayName: (
    filterType: TRESPONSE_LotListing['selectedFilters'][number]['filterType'],
    headerConfig: TRESPONSE_LotListing['headerConfig'],
    isConfigurableFiltersEnabled: boolean,
  ) => {
    const filterItem = headerConfig.find((item) => item.headerKey === filterTypeToHeaderKeyMap[filterType]);
    if (isConfigurableFiltersEnabled && filterItem) return `All ${filterItem.displayName}`;
    return fabricFilterToDisplayNameMap[filterType];
  },
  createModel: (
    items: TRESPONSE_LotListing['selectedFilters'],
    headerConfig: TRESPONSE_LotListing['headerConfig'],
    isConfigurableFiltersEnabled: boolean,
    stockType: TStockType,
    prevModel?: TFilterGroupModel<TRESPONSE_LotListing['selectedFilters'][number]>,
    addDate?: boolean,
    appDetails?: TAppDetails,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(
      items,
      (item) => {
        return {
          type: 'SELECT_FILTER',
          key: item.filterType,
          displayName: FABRIC_FILTER_LOT_LISTING_MODEL.getFiltersDisplayName(
            item.filterType,
            headerConfig,
            isConfigurableFiltersEnabled,
          ),
          ...(appDetails &&
            item.filterType !== 'LOT_STATUS' && {
              searchWithApi: {
                searchService: 'fabric-inspection',
                searchEndPoint: 'SEARCH_BCTX',
                appDetails: appDetails,
              },
            }),
          items: item.values.map((val) => {
            return {
              value: val,
              isSelected: false,
            };
          }),
          selectedValues: [],
          ...(item.values.length > 100 && {
            virtualScroll: {
              itemSize: 40,
              minBufferPx: window.screen.height,
              maxBufferPx: window.screen.height,
            },
          }),
        };
      },
      addDate ? DATE_FILTER : undefined,
    );

    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
};
